import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
export const callingTabUrl = (portalId, queryString) => {
  const subdomainPrefix = enviro.deployed() ? 'app' : 'local';
  return `${getFullUrl(subdomainPrefix)}/calling-page-application/${portalId}?${queryString}`;
};
export const getCallReviewPageUrl = (portalId, crmObjectId) => {
  return `${getFullUrl('app')}/calls/${portalId}/review/${crmObjectId}`;
};